export type RecipientDto = {
  avatar?: string;
  name: string;
  apartment: number;
  date?: Date;
};


export enum NotificationType {
  Required, Optional
};

export type CreateUpdateNotificationHotelRequestDto = {
  hotelId: string;
  allApartments: boolean;
  apartmentIds?: string[];
};

export type CreateNotificationRequestDto = {
  hotels?: CreateUpdateNotificationHotelRequestDto[];
  title?: string;
  message?: string;
  isRequired: boolean;
};

export enum NotificationCategory {
  Admin, Finances, Calendar, Orders
};

export type AdminNotificationsListItemRecipientResponseDto = {
  recipientId: string;
  recipientName?: string;
  recipientAvatar?: string;
};

export type AdminNotificationsListItemResponseDto = {
  id: string;
  title?: string;
  message?: string;
  sent: Date;
  category: NotificationCategory;
  isRequired: boolean;
  totalRecipients: number;
  totalRead: number;
  recipients?: AdminNotificationsListItemRecipientResponseDto[];
};

export type AdminNotificationsListResponseDto = {
  items?: AdminNotificationsListItemResponseDto[];
  totalCount: number;
};

export type OwnerNotificationsListItemResponseDto = {
  id: string;
  title?: string;
  message?: string;
  sent: Date;
  category: NotificationCategory;
  isRequired: boolean;  
  isRead:	boolean;
};

export type OwnerNotificationsListResponseDto = {
  items?: OwnerNotificationsListItemResponseDto[];
  totalCount: number;
};

export type NotificationDetailsReceiverResponseDto = {
  userId: string;
  userName?: string;
  avatar?: string;
  isRead:	boolean;
  readAt?: Date;
};

export type NotificationDetailsResponseDto = {
  id: string;
  title?: string;
  message?:	string;
  sent: Date;
  category: NotificationCategory;
  isRequired: boolean;
  recipients?: NotificationDetailsReceiverResponseDto[];
};

export enum NotificationsBarButtons {
  All,
  Admin,
  Finances,
  Calendar,
  Orders,
};